
  import * as storyblokRuntime$QOXQOB7TQecKD6f308NxKfkT_21FZc4w2aipzEZOzyM from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as vercelRuntime$WLiuqgVXqFTGGEVHJmiVy4mRYrpcq8NmWPhxXurqtXs from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/vercel'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$QOXQOB7TQecKD6f308NxKfkT_21FZc4w2aipzEZOzyM, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['vercel']: { provider: vercelRuntime$WLiuqgVXqFTGGEVHJmiVy4mRYrpcq8NmWPhxXurqtXs, defaults: {} }
    }
  }
